const checkOperationLink = (locationUrl: string): boolean => locationUrl.includes('operation')
export default checkOperationLink
